import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface RewardsState {
  loading: boolean;
  rewards: any | null;
  error: string | null;
  minimumReward: number;
  isFirstLoad: boolean;
}

const initialState: RewardsState = {
  loading: false,
  rewards: null,
  error: null,
  minimumReward: 10.0,
  isFirstLoad: true,
};

const rewardsSlice = createSlice({
  name: 'rewards',
  initialState,
  reducers: {
    rewardsRequest(state, action) {
      state.loading = true;
      state.error = null;
      state.isFirstLoad = true;
    },
    rewardsFetched(state, action: PayloadAction<any>) {
      state.loading = false;
      state.rewards = action.payload;
      state.error = null;
      state.isFirstLoad = false;
    },
    rewardsFetchFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
      state.isFirstLoad = false;
    },
    setMinimumReward(state, action: PayloadAction<number>) {
      state.minimumReward = action.payload;
    },
    resetRewardsSlice(state) {
      return initialState; // Reset the slice to its initial state
    },
  },
});

export const {
  rewardsRequest,
  rewardsFetched,
  rewardsFetchFailed,
  setMinimumReward,
  resetRewardsSlice,
} = rewardsSlice.actions;
export default rewardsSlice.reducer;
